import React from "react";
import "./PcaTestimonials.css";

const testimonials = [
  {
    quote: "Bidder iQ gave me the confidence to buy a 993 when I found it in a storage warehouse. I knew what the price range was because of Bidder iQ. Thanks!",
    name: "Mike Anderson",
    context: ""
  },
  {
    quote: "Bidder iQ has been so worthwhile to me as I have reviewed cars I've purchased recently and sold. It gives me an edge and confidence that required a lot more research to do before Bidder iQ.",
    name: "Joe Questel",
    context: ""
  }
];

function PcaTestimonials() {
  return (
    <section className="pca-testimonials" id="testimonials">
      <h2 className="pca-testimonials__headline">What Bidder iQ users say</h2>
      <div className="pca-testimonials__grid">
        {testimonials.map((testimonial, index) => (
          <figure className="pca-testimonials__card" key={index}>
            <blockquote className="pca-testimonials__quote">
              "{testimonial.quote}"
            </blockquote>
            <figcaption className="pca-testimonials__author">
              <div className="pca-testimonials__name">{testimonial.name}</div>
              {testimonial.context && (
                <div className="pca-testimonials__context">{testimonial.context}</div>
              )}
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
}

export default PcaTestimonials;
